<div class="fixed-header text-right pt-3 pe-3">
  <div class="action-buttons float-right">
    <button type="button" class="btn btn-secondary me-2" routerLink="/sales">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button type="button" class="btn btn-primary btn-primary-color" (click)="SaveVetUserProfile()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</div>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" color="accent" class="fixed-tabs">
  <mat-tab label="User Profile">
    <user-profile [isUseBuiltInSave]="false"></user-profile>
  </mat-tab>
  <mat-tab label="User Notification Settings" *ngIf="IsVet">
    <vet-user-notification-setting [isUseBuiltInSave]="false"></vet-user-notification-setting>
  </mat-tab>
  <mat-tab label="Admin Notification Settings" *ngIf="IsSalesCompany">
    <div class="container">
      <sale-admin-notification-setting-popup></sale-admin-notification-setting-popup>
    </div>
  </mat-tab>
  <mat-tab label="Company Profile">
    <div class="container" *ngIf="IsVet">
      <vet-profile [isUseBuiltInSave]="false"></vet-profile>
    </div>
    <div class="container" *ngIf="IsSalesCompany">
      <sales-company-profile [isUseBuiltInSave]="false"></sales-company-profile>
    </div>
  </mat-tab>
</mat-tab-group>
